// extracted by mini-css-extract-plugin
export default {"assignButton":"RememberedLearners_assignButton__La57x"};